import * as React from 'react';
import { Page } from '~/components/online-events-page/online-events-page';

const OnlineEventsPage: React.FC = () => <Page />;

export default OnlineEventsPage;
